import React from 'react';
import { Col } from 'react-bootstrap';
import erroregg from 'assets/img/spot-illustrations/redegg.png';
import successegg from 'assets/img/spot-illustrations/greenegg.png';
import errorimg from 'assets/img/spot-illustrations/redlight.png';
import successimg from 'assets/img/spot-illustrations/greenlight.png';

interface ModalProps {
  show: boolean;
  message: string | null;
  messageType: 'success' | 'error' | 'successupdate' | 'errorupdate';
  logout: boolean;
  onClose: () => void;
}

const FormResultMessage: React.FC<ModalProps> = ({
  show,
  message,
  messageType,
  logout,
  onClose
}) => {
  const handleClose = () => {
    if (logout) {
      window.location.href = '/authentication/sign-out';
    } else {
      onClose();
    }
  };

  if (!show) {
    return null;
  }

  let image = successegg;
  let msgtitle = 'Opps!';

  if (messageType === 'error') {
    image = erroregg;
    msgtitle = 'Something went wrong!';
  } else if (messageType === 'errorupdate') {
    image = errorimg;
    msgtitle = 'Something went wrong!';
  } else if (messageType === 'success') {
    image = successegg;
    msgtitle = 'Welldone!';
  } else if (messageType === 'successupdate') {
    image = successimg;
    msgtitle = 'Welldone!';
  }

  return (
    <div className="modal-overlay text-align-left">
      <div className="modal-content-msg bg-body-emphasis p-5 pb-1">
        <div className="modal-header">
          <h3>{msgtitle}</h3>
        </div>
        <div className="justify-content-center align-items-center g-5 d-flex">
          <Col className={`modal-body pt-2`}>
            <p>{message}</p>
            <button onClick={handleClose} className="btn btn-phoenix-secondary">
              Close
            </button>
          </Col>
          <Col>
            <img src={image} alt="" />
          </Col>
        </div>
      </div>
    </div>
  );
};

export default FormResultMessage;
